import React from 'react';
import PropTypes from 'prop-types';
import { Message } from '@nbc-design/message';
import { Col, Row } from 'react-flexbox-grid';

export type ErrorMessageDisplayProps = {
  visible: boolean;
  message?: string | null;
};

const ErrorMessageDisplay: React.FunctionComponent<ErrorMessageDisplayProps> = (props) => {
  const { visible, message } = props;

  if (!visible) return null;

  return (
    <Row className="error-message py-6 has-error">
      <Col xs={6} md={12} lg={12}>
        {visible && <Message appearance="error">{message}</Message>}
      </Col>
    </Row>
  );
};

ErrorMessageDisplay.propTypes = {
  visible: PropTypes.bool.isRequired,
  message: PropTypes.string,
};

export default ErrorMessageDisplay;
